<template>
	<div class="mm-page-main">
		<div v-for="(data,index) in datas" :key="index">
			<div class="page-header">
				<div v-if="data.either == 0" class="page-title">指示人資料</div>
				<div v-else-if="data.either == 1" class="page-title">兌換人資料</div>
			</div>
			<div class="pagemain">
				<div class="form-group">
					<div class="form-group-content">
						<div class="mm-row">
							<div class="mm-col">
								<div class="mm-item mb20">
									<label class="mm-label">會員類別：</label>
									<el-radio-group disabled v-model="data.type">
										<el-radio-button  label="0">個人</el-radio-button>
										<el-radio-button  label="1">企業</el-radio-button>
										<el-radio-button  label="2">行家</el-radio-button>
									</el-radio-group>
								</div>
							</div>
						</div>
						<div v-if="data.type == 0"><person :data="data"></person></div>
						<div v-if="data.type == 1"><company :data="data"></company></div>
						<div v-if="data.type == 2"><connoisseur :data="data"></connoisseur></div>
					</div>
				</div>
				
			</div>
		</div>
		
	</div>
</template>

<script>
	import person from "@/components/PersonInfo.vue";
	import company from "@/components/CompanyInfo.vue";
	import connoisseur from "@/components/ConnoisseurInfo.vue";
	export default {
		components: {
			person,
			company,
			connoisseur
		},
		props:['customer_id'],
		data() {
			return {
				clientpage:'person',
				datas:[]
			};
		},
		methods: {
			
			getdata() {
				this.post('/api/customer/customerinfo', {
					customer_id: this.customer_id,
				}).then((res) => {
					this.datas = res;
				}).catch((err) => {
			
					console.log(err)
				})
			}
		},
		created() {
			
			this.getdata();
		}

	};
</script>
<style scoped>
	


	

	

	
</style>
